import "./MicroNirPatw.module.css";
import Header from "@/reusable_sections/Header";
import MicroNir from "./sections/MicroNir";
import Applications from "./sections/Applications";
import RelatedSolutions from "./sections/RelatedSolutions";
import RelatedServices from "./sections/RelatedServices";
import DiscussApplication from "./sections/DiscussApplication";
import Footer from "@/reusable_sections/Footer";
export default function MicroNirPatwPage() {
  return <div>
      <Header />
      <MicroNir />
      <Applications />
      <RelatedSolutions />
      <RelatedServices />
      <DiscussApplication />
      <Footer />
    </div>;
}